import React, { useState } from 'react';
import cn from 'classnames';
import { find, noop } from 'lodash';
import pathfinder from '@fiverr-private/pathfinder';
import { triggerSignIn } from '@fiverr-private/identification_triggers';
import {
    Slider,
    DotsIndicator,
    FavoriteButton,
    CupMockUp,
    CardsMockUp,
    LaptopMockUp,
    PhonesMockUp,
    Variation,
    setVariationTextFields,
} from '@fiverr-private/variations_display';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import { getContext } from '@fiverr-private/fiverr_context';
import { SAMPLES_SLIDER } from '../propTypes';
import { useChooseVariationContext } from '../Context';
import { useFavoritesContext } from '../FavoritesContext';
import MockupIdentity from './MockupIdentity';
import { FAVORITE_SAMPLES_SLIDER_CLASSNAME } from './constants';
import classes from './style.module.scss';

const { reportAddToFavorites, reportRemoveFromFavorites } = makersExperience.chooseVariation;

const { Location } = reportAddToFavorites;

const SamplesSlider = ({ isMobile = false, onMainSampleRendered = noop }) => {
    const { addToFavorites, removeFromFavorites, isFavorite } = useFavoritesContext();
    const { variations: allVariations } = useChooseVariationContext();

    const { userId } = getContext();
    const [activeVariationIndex, setActiveVariationIndex] = useState(0);
    const [direction, setDirection] = useState(null);

    const { brandName, slogan, selectedVariation, variations, selectedVariationId } = useChooseVariationContext();

    const variationWithoutText = find(variations, ['id', selectedVariation.id]);
    const variation = setVariationTextFields({
        variation: variationWithoutText,
        brandName,
        slogan,
    });

    const slides = [
        {
            component: Variation,
            ...variation,
            withWatermark: true,
            scale: 0.865,
            id: 0,
            onTextFieldsRenderTick: onMainSampleRendered,
        },
        { component: CupMockUp, variation, isSquare: true, id: 1 },
        { component: CardsMockUp, variation, isSquare: true, id: 2 },
        { component: PhonesMockUp, variation, isSquare: true, id: 3 },
        { component: LaptopMockUp, variation, isSquare: true, id: 4 },
    ];

    const changeSavedProject = async (status) => {
        if (!userId) {
            try {
                await triggerSignIn({
                    modalOptions: {
                        triggerType: 'blocked_action',
                    },
                });
            } catch {
                window.location = pathfinder('login_page');
            }
        } else {
            const variationPosition = allVariations.findIndex(({ id }) => id === selectedVariationId) + 1;
            status
                ? reportAddToFavorites(variationPosition, Location.VARIATIONS)
                : reportRemoveFromFavorites(variationPosition, Location.VARIATIONS);

            const result = await (status ? addToFavorites() : removeFromFavorites());

            return result;
        }
    };

    return (
        <div className={cn(classes.samplesSlider, FAVORITE_SAMPLES_SLIDER_CLASSNAME)}>
            {isMobile && (
                /* Following node is needed to prefetch images to prevent overflowing issue on ios browsers */
                <div style={{ display: 'none' }}>
                    <CupMockUp variation={variation} isSquare />
                </div>
            )}
            <DotsIndicator
                className={classes.mockupsDotsIndicator}
                activeIndex={activeVariationIndex}
                total={slides.length}
                direction={direction}
                setDirection={setDirection}
            />
            <Slider
                isMobile
                initialIndex={activeVariationIndex}
                onSlideChange={setActiveVariationIndex}
                setDirection={setDirection}
                slides={slides}
                Component={MockupIdentity}
            />
            <FavoriteButton
                className={classes.samplesSliderSaveBtn}
                isFavorite={isFavorite}
                onChange={changeSavedProject}
            />
        </div>
    );
};

SamplesSlider.propTypes = SAMPLES_SLIDER;

export default SamplesSlider;
